const MIN_VALID_DIMENSION = 2;

export function validateImageDimensions(url: string): Promise<boolean> {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      resolve(img.naturalWidth >= MIN_VALID_DIMENSION && img.naturalHeight >= MIN_VALID_DIMENSION);
    };
    img.onerror = () => {
      resolve(false);
    };
    img.src = url;
  });
}
